export default __webpack_public_path__ + "static/media/redeem-bonus1-m-1.5052e6a7.webp";